/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import axios from 'axios';
import { getStore } from 'store/accessor';
import { ENVIRONMENT } from 'config';
import { isTokenExpired } from '../helpers/jwt';
import TIME_OUTS from '../constants/time-outs';
import { getClientId } from './client-id';
import { refreshTokens } from './refresh-token';

//
const httpClient = axios.create({
  baseURL: ENVIRONMENT.BACKEND_API,
  timeout: TIME_OUTS.REQUEST_TIMEOUT_MS,
  timeoutErrorMessage: 'Request timed out',
});
/**
 * Here is the axios request interceptor. Here we add the request header into the
 */
httpClient.interceptors.request.use(async (requestConfig) => {
  const config = requestConfig;
  const accessToken = getStore()?.getState()['feature/base-auth']?.tokens?.accessToken;
  if (accessToken && Object.hasOwn(config.headers, 'Authorization')) {
    // check whether access token need to be refreshed before execute api call
    if (isTokenExpired(accessToken, TIME_OUTS.ACCESS_TOKEN_REFRESH_LEEWAY)) {
      const tokenData = await refreshTokens();
      config.headers.Authorization = `Bearer ${tokenData.accessToken}`;
    } else {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
  }
  config.headers['X-Client-ID'] = getClientId();
  return config;
});
//
export default httpClient;
  